import React from 'react';
import { Variable } from '@/types/TVariables';
import VariableItem from './VariableItem';

interface VariableListProps {
	variables: Record<string, Variable>;
	onEdit: (name: string, data: Variable) => void;
	onDelete: (name: string) => void;
}

const VariableList: React.FC<VariableListProps> = ({ variables, onEdit, onDelete }) => {
	return (
		<div className="space-y-3">
			{Object.entries(variables).length === 0 ? (
				<div
					className="flex flex-col items-center justify-center py-6 sm:py-8 lg:py-12 px-3 sm:px-4 
                      bg-slate-50/50 rounded-xl sm:rounded-2xl border-2 border-dashed border-slate-200"
				>
					<div className="p-3 sm:p-4 bg-slate-100 rounded-full mb-3 sm:mb-4">
						<svg
							className="w-6 h-6 sm:w-8 sm:h-8 text-slate-400"
							fill="none"
							viewBox="0 0 24 24"
							stroke="currentColor"
						>
							<path
								strokeLinecap="round"
								strokeLinejoin="round"
								strokeWidth={2}
								d="M12 6v6m0 0v6m0-6h6m-6 0H6"
							/>
						</svg>
					</div>
					<h3 className="text-base sm:text-lg font-medium text-slate-700 mb-1">No Variables Yet</h3>
					<p className="text-sm text-slate-500 text-center max-w-xs sm:max-w-sm">
						Create your first variable to start personalizing your content dynamically.
					</p>
				</div>
			) : (
				<div className="grid gap-3">
					{Object.entries(variables).map(([name, data]) => (
						<VariableItem key={name} name={name} data={data} onEdit={onEdit} onDelete={onDelete} />
					))}
				</div>
			)}
		</div>
	);
};

export default VariableList;
